import { useCallback, useEffect, useState } from "react";
import { Preferences } from "../../components/profile/preferences";
import { useSearchParams } from "react-router-dom";
import { GeneralInfo } from "../../components/profile/generalInfo";
import { Notifications } from "../../components/profile/notifications";
import { StyledSelectWoController } from "../../components/styled/StyledSelectWoController";
import { TabNavigation } from "../../components/backOffice/tabNavigation";
import { Statistics } from "../../components/profile/statistics";

export const ProfilePage = () => {
  const [searchParams, setSearchParams] = useSearchParams();
  const [activeTab, setActiveTab] = useState<number>(Number(searchParams.get("tab")) || 0);

  const displayTab = () => {
    switch (activeTab) {
      case 0:
        return <Statistics />;
      case 1:
        return <Preferences />;
      case 2:
        return <GeneralInfo />;
      case 3:
        return <Notifications />;
      default:
        return null;
    }
  };

  const updateSearchParams = useCallback(() => {
    if (activeTab === 2) {
      setSearchParams({
        tab: activeTab.toString(),
        subTab: searchParams.get("subTab") || "0",
      });
    } else {
      setSearchParams({ tab: activeTab.toString() });
    }
  }, [activeTab, searchParams, setSearchParams]);

  useEffect(() => {
    updateSearchParams();
  }, [updateSearchParams]);

  return (
    <div className="flex h-fit w-full flex-1 flex-col gap-4 p-4 md:gap-8 md:p-8">
      <div className="flex flex-col gap-6">
        <div className="flex flex-col gap-2">
          <h1 className="font-jakarta-sans text-3xl font-semibold">Profil</h1>
          <p>Entrez les informations de livraison</p>
        </div>
        <div className="hidden flex-1 flex-row border-b border-gray-200 md:flex">
          <TabNavigation
            activeTab={activeTab}
            setActiveTab={setActiveTab}
            texts={["Statistiques", "Préférences", "Informations générales", "Notifications"]}
          />
        </div>
        <div className="flex w-full items-center justify-center md:hidden">
          <StyledSelectWoController
            placeholder="Filtrer"
            isClearable={false}
            isSearchable={false}
            options={[
              { label: "Statistiques", value: "0" },
              { label: "Préférences", value: "1" },
              { label: "Informations générales", value: "2" },
              { label: "Notifications", value: "3" },
            ]}
            value={activeTab.toString()}
            onChange={(e) => setActiveTab(Number(e?.value || "0"))}
            className="w-full self-start rounded-lg bg-gray-100 p-1"
          />
        </div>
      </div>
      {displayTab()}
    </div>
  );
};
